import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "../shared-components/SharedComponents/CelebrationModal.css";
import CelebrationModal from '../shared-components/celebration_modal';
import NumberedListFancyCard from '../shared-components/numbered_list_fancy_card.js';
import determineBadgeInfo from './objects/determine_badge_info.js';
import determineAchievementDisplayInfo from './objects/determine_achievement_display_info.js';


class AwardInfoModal extends Component {
            constructor(props) {
              super(props);
              this.gameInfo = this.props.gameInfo;
              this.state={
                celebrationModal: false,
                badgeMaxParts: 2
            };  
        this.statusTextArr = [];
    }

    initializeDisplay(){
         //  achievementSlctd is ==> id: achievementList[i].achievementID, earned: "", imgSrc: ""
        const achievementSlctd = this.props.achievementSlctd; 
        this.achievementName = "";
        this.achievementTitle = "";
        this.achievementDesc = "";
        this.imgSrc =  achievementSlctd.imgSrc;
        if (this.props.achievementType === "BDG"){
            this.determineBadgeInfo(achievementSlctd.id, achievementSlctd);
        }else{
            this.determineAchievementInfo(achievementSlctd.id, achievementSlctd);
        }
        let celebrate = false;
        if (achievementSlctd.earned === true){
            celebrate = true;
        }
        this.setState({celebrationModal: celebrate});
       
    }
    
    determineBadgeInfo(badgeInfo, achievementSlctd){
        const badgeDisplay = determineBadgeInfo(badgeInfo, achievementSlctd,  
            this.gameInfo.gameData.badgesEarned);
        this.achievementName = badgeDisplay.badgeName;
        this.achievementType = badgeDisplay.badgeType;
        this.achievementAnimation = badgeDisplay.badgeAnimation;
        this.achievementTitle = badgeDisplay.badgeTitle;
        this.achievementDesc = badgeDisplay.badgeDesc;
        this.additionalText = badgeDisplay.additionalText;
        this.link = "";
    }

    determineAchievementInfo(achievementId, achievementSlctd){
        let investmentActive = false;
        if (this.gameInfo.gameInvestments.length){
            for (let i=0; i<this.gameInfo.gameInvestments.length; i++){
                if (this.gameInfo.gameInvestments[i].currentlyActive === true){
                    investmentActive = true;
                    break;
                }
            }
        }
     
        const achievementInfoObj = 
            determineAchievementDisplayInfo(achievementId, achievementSlctd, 
                this.gameInfo.creditCardInfo,
                this.gameInfo.gameData,
                this.gameInfo.totalGameMonths,
                investmentActive, 
                this.gameInfo.timeWizardInfo,
                this.gameInfo.savingsInfo,
                this.gameInfo.summaryInvestment,
                this.gameInfo.investmentMaster,
                this.gameInfo.moneyMgmtTestArr
            );
        this.achievementType = achievementInfoObj.achievementType;
        this.achievementName = achievementInfoObj.achievementName; 
        this.achievementTitle = achievementInfoObj.achievementTitle;
        this.achievementID = achievementId;
        this.additionalText = achievementInfoObj.additionalText;
        this.achievementDesc = achievementInfoObj.achievementDesc;
        this.statusTextArr = achievementInfoObj.statusTextArr;
        this.link = achievementInfoObj.link;
        this.linkText = achievementInfoObj.linkText;
        this.earnedText = achievementInfoObj.earnedText;
    }

    closeCelebrationModal(){
        this.props.onClose();
    }

    goToLink(linkName){
         this.props.onNavigate(linkName);
    }

    render() {
        let achievementAnimation = "";
        if (this.achievementID){
            achievementAnimation = this.achievementType;
            if (this.achievementID.substring(0,1) === "J"){
                achievementAnimation = "jewel"
            }
        }
        if (this.statusTextArr){
            this.statusInfo = this.statusTextArr.map((textLine, key) =>
            <NumberedListFancyCard key={key} text={textLine} />
            );
        }
        let awardIDPosition = "trophy-id-position";
        if (this.achievementID && this.achievementID.substring(0,1) === "J"){
            awardIDPosition = "jewel-id-position";
        }
    return <>
         {this.state.celebrationModal   ? 
            <CelebrationModal
                isOpen={this.state.celebrationModal}
                onClose={() => {this.closeCelebrationModal(); // optionally close parent too
                }}
                type={achievementAnimation}
                title={this.achievementTitle}
                description={this.additionalText}
                imgSrc={this.imgSrc}
                trophyID={this.achievementID}
            />
        :
            <Modal dialogClassName="modal-with-rounded-corners modal-rounded-corners-size" 
                show={this.props.modalOpen}  
                onHide={() => this.props.onClose()}  
                animation={false}>
               
                <Modal.Body className="">
                    <div>
                        <div className="text-center">
                            <img className="trophy_thumbnail_img" src={this.imgSrc} 
                                alt="trophy"/>
                            {this.achievementType === "trophy" ?
                                <div className={awardIDPosition}>{this.achievementID}</div>
                            :
                                null
                            }
                        </div>
                        <div className="text-center celebration-label mt-2">
                            {achievementAnimation}
                        </div>
                        <h4 className="text-center celebration-title">
                            {this.achievementTitle}         
                        </h4>
                        <div className = "mt-2">
                                {this.achievementDesc}
                        </div>
                        {this.achievementType === "badge" ?
                            <div className = "mt-2">
                                {this.additionalText}
                            </div>
                        :
                            <div className = "mt-2">
                                {this.statusInfo}
                                <div>
                                    {this.earnedText}
                                </div>
                                {this.link !== ""  ?
                                    <div className="mt-2">
                                        <div>
                                            {this.linkText}  
                                        </div>
                                        <div
                                            className="decorative light-blue-color text-center text-pointer "
                                                onClick={() => this.goToLink(this.link)}><u>Link</u>
                                        </div>
                                    </div>
                                :
                                    null
                                }
                            </div>
                        }
                    </div>
                
                </Modal.Body>
                <Modal.Footer className="p-0">
                   <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Button variant="primary" onClick={() => this.props.onClose()}>
                        Close
                    </Button>
                    </div>
                </Modal.Footer>
                </Modal>
            }
        </>
    }

    componentDidMount(){
        this.initializeDisplay();
    }
}

export default AwardInfoModal;